import { Button, KIND, SIZE } from 'baseui/button'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'
import { Show } from 'baseui/icon'
import ModalLogs from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/HistoricAuditLogs/ModalLogs'
import useHistoricAuditLogs from '@/containers/SubscriptionFormPageNew/Components/Tools/HistoricAuditLogs/useHistoricAuditLogs'

const HistoricAuditLogs = () => {
  const { t, isAdmin, isOpen, close, logs, fetchLogs } = useHistoricAuditLogs()

  if (isAdmin === false) {
    return ''
  }

  return (
    <>
      <Button kind={KIND.secondary} size={SIZE.compact} onClick={fetchLogs} startEnhancer={() => <Show size={24} />}>
        {t('subscriptionForm:subscription_actions_module.historic_logs.view_historic_logs_button')}
      </Button>

      <Modal
        onClose={close}
        isOpen={isOpen}
        size={SIZE.auto}
        overrides={{
          Dialog: {
            style: {
              width: '80vw',
            },
          },
        }}
      >
        <ModalHeader>{t('subscriptionForm:subscription_actions_module.historic_logs.modal_header')}</ModalHeader>
        <ModalBody style={{ flex: '1 1 0' }}>
          <ModalLogs data={logs} />
        </ModalBody>
        <ModalFooter>
          <ModalButton kind={KIND.primary} onClick={close}>
            {t('subscriptionForm:subscription_actions_module.historic_logs.modal_close_button')}
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default HistoricAuditLogs
